import { AIRPORT_OPTIONS_Q_MAX, AIRPORT_OPTIONS_Q_MIN, type AirportOption } from "@seagames/contracts";

/**
 * The airport picker's pure rules (unit-tested in `airports.test.ts`).
 *
 * Picking an airport writes `City (IATA)` into the leg's free-text origin —
 * the same `origin` text as before (≤ TRAVEL_ORIGIN_MAX), so nothing about
 * what is saved changes. An airport with no city falls back to its name.
 */
export function airportLabel(a: Pick<AirportOption, "city" | "name" | "iata_code">, max?: number): string {
	const place = (a.city ?? "").trim() || a.name.trim();
	const label = `${place} (${a.iata_code})`;
	if (max === undefined || label.length <= max) return label;
	// Too long for the field: keep the code, shorten the place.
	const room = Math.max(1, max - ` (${a.iata_code})`.length - 1);
	return `${place.slice(0, room).trimEnd()}… (${a.iata_code})`;
}

/**
 * What is sent as `q`, or null when nothing should be asked: trimmed (the API
 * trims too, bug 5), at least AIRPORT_OPTIONS_Q_MIN characters, cut at
 * AIRPORT_OPTIONS_Q_MAX. A value that is already a picked label (`Bangkok (BKK)`)
 * searches by its code, so reopening the list finds the same airport first.
 */
export function airportSearchTerm(text: string): string | null {
	const t = text.trim();
	const picked = /\(([A-Z]{3})\)$/.exec(t);
	const q = (picked ? picked[1]! : t).slice(0, AIRPORT_OPTIONS_Q_MAX);
	return q.length >= AIRPORT_OPTIONS_Q_MIN ? q : null;
}
